import { useTranslation as useI18nTranslation } from "react-i18next";

import {
  changeLanguageWithTenant,
  DAYJS_LOCALE_MAP,
} from "../multitenancy/i18n";

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();

  const changeLanguage = async (language: string) => {
    await changeLanguageWithTenant(language);
  };

  const currentLanguage = i18n.language;
  const dayjsLocale = DAYJS_LOCALE_MAP[currentLanguage] ?? "pt-br";

  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage,
    dayjsLocale,
  };
};

export default useTranslation;
